import { Component } from '@angular/core';

@Component({
  selector: 'bb-showcase',
  templateUrl: './showcase.component.html',
  styleUrl: './showcase.component.scss',
  standalone: false,
})
export class ShowcaseComponent {}
